<script setup>
import { useFooterSectionStore } from '@/stores/footer_sections';

const footerSectionStore = useFooterSectionStore();
const is_chat_enabled = process.env.VUE_APP_CHAT_ENABLED == 'true';
const zendeskEnabled = process.env.VUE_APP_ZENDESK_ENABLED == 'true';

const unlockTawkBodyLock = () => {
	const body = document.body;
	const html = document.documentElement;

	body.style.removeProperty('position');
	body.style.removeProperty('top');
	body.style.removeProperty('left');
	body.style.removeProperty('right');
	body.style.removeProperty('width');
	body.style.removeProperty('height');
	body.style.removeProperty('min-height');
	body.style.removeProperty('max-height');
	body.style.removeProperty('max-width');
	body.style.removeProperty('overflow');

	html.style.removeProperty('overflow');

	if (location.hash === '#max-widget') {
		history.replaceState(null, document.title, location.pathname + location.search);
	}
};

const openChat = () => {
	const y = window.scrollY || window.pageYOffset || 0;

	document.activeElement?.blur?.();

	window.Tawk_API?.toggle?.();

	const fix = () => {
		unlockTawkBodyLock();
		window.scrollTo(0, y);
	};

	requestAnimationFrame(fix);
	setTimeout(fix, 50);
	setTimeout(fix, 200);
};

const openZendesk = () => {
	window.zE('webWidget', 'toggle');
};

</script>

<template>
	<template v-if="footerSectionStore.getLivechatSection">
		<div class="contact-flex">
			<div class="mobile-width">
				<template v-if="is_chat_enabled">
				<button type="button" class="btn-small btn-secondary" style="height: 39px; width: 140px;" @click.prevent="openChat"> {{ $t('general.live_chat') }}</button>
				</template>
				<template v-else-if="zendeskEnabled">
					<a href="javascript:void(0);" class="btn-small btn-secondary" @click.prevent="openZendesk" style="height: 39px; width: 140px;">{{ $t('general.live_chat') }}</a>
				</template>
				<template v-else>
					<a href="javascript:void(0);" class="btn-small btn-secondary" style="height: 39px; width: 140px;">{{ $t('general.live_chat') }}</a>
				</template>
		</div>
		</div>
	</template>
</template>

<style scoped>
.contact-flex {
	display: flex;
	align-items: flex-end;
	justify-items: start;
	flex-wrap: wrap;
	gap: 10px;
}
.contact-title {	color: var(--white);
	font-size: 13px;
	text-align: center;
	font-weight: 700;
	padding-bottom: 5px;
}
.contact-number {
	color: var(--primary);
	font-weight: 700;
	text-decoration: none;
}

.contact-number-ussd {
	color: var(--primary);
	font-weight: 700;
}

.no-hover {
	color: var(--primary);
	font-weight: 700;
	pointer-events: none;
	cursor: default;
}

.no-border {
	border: none;
	text-align: left;
}

@media screen and (max-width: 767px){
	.contact-flex {
		justify-content: space-between;
	}

	.btn-small {
		font-size: 13px;
		text-wrap: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.mobile-width {
		width: 44%;
	}
}

@media screen and (min-width: 768px) and (max-width: 991px) {
	.btn-small {
		font-size: 13px;
		padding: 7px;
	}
}
</style>